import { defaultPais, PaisProps } from "./PaisInterface";

//Definición de defaults

export const defaultEstado: EstadoProps = {
    idEstado:       0,
    clave:          '',
    descripcion:    '',  
    idPais:         0,
    pais:           defaultPais,
    activo:         false,
}

// Creación de interfaces

export interface EstadoProps{
    idEstado:       number;
    clave:          string;
    descripcion:    string;
    activo:         boolean;
    idPais:         number;
    pais?:          PaisProps;
}